import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";
import { StaggerGroup, fadeUp } from "@/components/motion/Reveal";
import TestimonialCard from "@/components/TestimonialCard";
import { CardGridSkeleton, QueryBoundary } from "@/components/states";
import { useTestimonials } from "@/hooks/content";

// Home testimonials strip — the three highest-ordered published testimonials,
// managed from the admin panel.
export default function TestimonialsSection() {
  const query = useTestimonials();

  return (
    <section className="section-pad" data-testid="testimonials-section">
      <div className="container-sky">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            eyebrow="Client Feedback"
            title="Trusted by Organisations Across Singapore"
            // TODO(handover): drop the parenthetical once the client has
            // entered their own testimonials through the admin panel.
            description="What clients say about working with SKY. (Demo testimonials shown until client-supplied testimonials are added.)"
          />
          <Link to="/testimonials" className="btn-outline-sky shrink-0">
            All Testimonials <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="mt-12">
          <QueryBoundary
            query={query}
            skeleton={<CardGridSkeleton count={3} className="grid gap-6 md:grid-cols-3" />}
            // A missing strip reads better than an error panel on the homepage.
            hideOnError
          >
            {(items) => (
              <StaggerGroup className="grid gap-6 md:grid-cols-3">
                {items.slice(0, 3).map((t) => (
                  <motion.div key={t.id} variants={fadeUp()}>
                    <TestimonialCard t={t} />
                  </motion.div>
                ))}
              </StaggerGroup>
            )}
          </QueryBoundary>
        </div>
      </div>
    </section>
  );
}
